import { createElement } from '@max/max';
import View from '@hfe/max-view';
import Price from '@max/leez-price';
import Text from '@max/leez-text';
import ExpiredTime from '../expired-time';
import Button from '../button';
import InflateLogo from '../inflate-logo';
import { getDescText, getPriceText } from '../../utils/coupon';
import './index.scss';
export default function TwoColCoupon(props) {
    const { formatCouponConfigRes, style = {}, index, couponData, amountColor, currentTimeMillis, toastConfig, updateCouponList, setCurrentTimeMillis, location, isShowContainer, bizLine, hotelchannel } = props || {};
    const { title = '', beginTime, status } = couponData || {};
    const inlineStyle = {
        containerStyle: Object.assign({ boxSizing: 'border-box', marginRight: '12rpx', borderRadius: '18rpx', width: isShowContainer ? '333rpx' : '345rpx' }, style),
        titleStyle: {
            backgroundColor: '#FFF',
            position: 'relative',
            top: '-4rpx'
        }
    };
    return <View className="two-col-container" style={inlineStyle.containerStyle}>
        <InflateLogo type="two" status={status}/>
        <View className="two-col-left">
          <View className="two-col-left-content">
            <Price content={getPriceText(couponData)} type="l2" showSymbol crossed={false} fontWeightType="bold" color={amountColor} smallDecimal={true}/>
            <Text style={{
            height: '28rpx'
        }} className="two-col-desc" text={getDescText(couponData)} type="label2" color={amountColor} lineClamp={1}></Text>
          </View>
        </View>
        <View className="two-col-right">
          <Text style={inlineStyle.titleStyle} text={title.slice(0, 7)} type="title5" lineClamp={1}/>
          <ExpiredTime location={location} containerStyle={{
            marginTop: '4rpx'
        }} updateCouponList={updateCouponList} formatCouponConfigRes={formatCouponConfigRes} couponData={couponData} currentTimeMillis={currentTimeMillis} setCurrentTimeMillis={setCurrentTimeMillis}/>
          <Button location={location} style={{
            marginTop: '8rpx'
        }} formatCouponConfigRes={formatCouponConfigRes} index={index} updateCouponList={updateCouponList} toastConfig={toastConfig} currentTimeMillis={currentTimeMillis} setCurrentTimeMillis={setCurrentTimeMillis} beginTime={beginTime} couponData={couponData} size={'small'} amountColor={amountColor} bizLine={bizLine} hotelchannel={hotelchannel}/>
        </View>
      </View>;
}
